export enum LayersEnum {
    Main = 0,
    Quotes = 1,
    CrossHair = 2,
    Tools = 3
}
